document.addEventListener("teeinblue-event-after-cart-added", () => {
  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
      .then((res) => res.json())
      .then((res) => drawer.renderContents({ sections: res }));
    if (drawer.classList.contains("is-empty"))
      drawer.classList.remove("is-empty");
  }
});

// setInterval(() => {
//   document.querySelectorAll(".tee-preview-button__text").forEach((e) => {
//     e.textContent = "Vorschau";
//   });
// }, 200);

// translate preview button
document.addEventListener("DOMContentLoaded", () => {
  const previewText = window.location.pathname.includes('/en/') ? 'Preview' : 'Vorschau'
  const updateAllPreviewButtons = () => {
    document.querySelectorAll(".tee-preview-button__text").forEach((btn) => {
      if (btn.textContent !== previewText) {
        btn.textContent = previewText;
      }
    });
  };

  updateAllPreviewButtons();

  const observer = new MutationObserver(updateAllPreviewButtons);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// move element
document.addEventListener('teeinblue-event-component-injected', function() {
  const elementToMove = document.querySelector('.product__tax');
  const insertAfterElement = document.querySelector('.tee-block.tee-product-price');
  if (elementToMove && insertAfterElement) {        
    insertAfterElement.after(elementToMove);
    elementToMove.style.marginTop = '-10px';
  } 

  moveElementAfter('.product__tax.rte', '.tee-product-price');
});

const moveElementAfter = (target, after) => {
  const targetEl = document.querySelector(target);
  const afterEl = document.querySelector(after);
  if (targetEl && afterEl) {
    afterEl.after(targetEl);
  }
};

/* Jason - 10152025 - START */
function translateATCButton(rootEl) {
  var ATCbtn = rootEl.querySelector('.tee-btn__text');
  if(ATCbtn) {
    const isEnglish = window.location.pathname.includes('/en/');
    ATCbtn.innerHTML = isEnglish
      ? 'Save Personalization'
      : 'Personalisierung sichern';
  }
}

function observePreviewPopup() {
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {

        if (!(node instanceof HTMLElement)) continue;

        if (node.classList.contains("tee-dialog-gallery")) {
          setTimeout(() => {
            translateATCButton(node);
          }, 100);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('teeinblue-event-component-injected', function() {
  observePreviewPopup();
});
/* Jason - 10152025 - START */


// (() => {
//   const DRAWER = '#CartPopup';
//   const ITEM = '.upcart-product-item';
//   const ANCHOR = '.upcart-item-properties-anchor-after';
//   const PREVIEW_CLASS = 'tee-preview-design';

//   async function fetchCartCids() {
//     const res = await fetch('/cart.js', { credentials: 'same-origin' });
//     const cart = await res.json();
//     return (cart.items || []).map(it => it?.properties?._customization_id || '');
//   }

//   function insertPreview(item, cid) {
//     if (!cid) return;
//     const anchor = item.querySelector(ANCHOR);
//     if (!anchor) return;
//     const exists = item.querySelector(`.${PREVIEW_CLASS}[data-customization-id="${cid}"]`);
//     if (exists) return;
//     const el = document.createElement('div');
//     el.className = PREVIEW_CLASS;
//     el.setAttribute('data-customization-id', cid);
//     el.setAttribute('onclick', "document.querySelector('.upcart-header-close-button').click()");
//     anchor.insertAdjacentElement('afterend', el);
//   }

//   let running = false;
//   async function syncPreviews() {
//     if (running) return;
//     running = true;
//     try {
//       const drawer = document.querySelector(DRAWER);
//       if (!drawer) return;
//       const cids = await fetchCartCids();
//       const nodes = Array.from(drawer.querySelectorAll(ITEM));
//       nodes.forEach((item, idx) => insertPreview(item, cids[idx] || ''));
//     } finally {
//       running = false;
//     }
//   }

//   let debTimer = null;
//   function debouncedSync() {
//     if (debTimer) cancelAnimationFrame(debTimer);
//     debTimer = requestAnimationFrame(syncPreviews);
//   }

//   function watchDrawer(drawer) {
//     const mo = new MutationObserver(debouncedSync);
//     mo.observe(drawer, { childList: true, subtree: true });
//     syncPreviews();
//   }

//   function init() {
//     const existing = document.querySelector(DRAWER);
//     if (existing) watchDrawer(existing);
//     const observer = new MutationObserver(() => {
//       const d = document.querySelector(DRAWER);
//       if (d) watchDrawer(d);
//     });
//     observer.observe(document.documentElement, { childList: true, subtree: true });
//     document.addEventListener('upcart:changed', debouncedSync);
//     document.addEventListener('cart:refresh', debouncedSync);
//   }

//   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
//   else init();
// })();